module.exports = __webpack_public_path__ + "img/040.b4709f05.png";